// ==========================
// Version 1 — nft/mintDisclosure.js
// - Builds the public-data summary shown immediately before wallet approval
// ==========================

function displayValue(value, fallback = 'Not provided') {
  const clean = value == null ? '' : String(value).trim();
  return clean || fallback;
}

export function buildMintDisclosureItems({ memory, memoryId, walletAddress }) {
  const lat = memory?.location?.lat ?? memory?.lat;
  const lng = memory?.location?.lng ?? memory?.lng;
  const hasCoordinates = Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));
  const imageCount = Array.isArray(memory?.imageUrls)
    ? memory.imageUrls.filter(Boolean).length
    : memory?.imageUrl
      ? 1
      : 0;

  return [
    {
      label: 'Image',
      value: imageCount
        ? `Generated NFT image using this memory and ${imageCount} public ${imageCount === 1 ? 'photo' : 'photos'}`
        : 'Generated NFT image of this memory',
    },
    {
      label: 'Story',
      value: memory?.story ? 'Included in the public memory and generated NFT image' : 'No story provided',
    },
    {
      label: 'Date and time',
      value: [memory?.date, memory?.time].filter(Boolean).join(' at ') || 'Not provided',
    },
    {
      label: 'Exact coordinates',
      value: hasCoordinates
        ? `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`
        : 'Not available',
    },
    {
      label: 'Memory ID',
      value: displayValue(memoryId || memory?.firestoreId || memory?.id, 'Not available'),
    },
    {
      label: 'Wallet address',
      value: displayValue(walletAddress, 'Not connected'),
    },
  ];
}

// ==========================
// End Version 1 — nft/mintDisclosure.js
// ==========================
